<template >
  <v-container id="element_to_intercept" class="brownClass" padding>
    <h3 class="title-download">Download</h3>
    <!--<h3 class="subtitle-download">
      {{subtitle}}
    </h3> -->
    <!-- FIRST ROW -->
    <div class="column-download">
      <checkboxcomponent :item1="item1" />
      <checkboxcomponent :item1="item3" />
      <checkboxcomponent :item1="item7" />
    </div>
    <div class="column-download"> 
      <checkboxcomponent :item1="item4" />
      <checkboxcomponent :item1="item5" />

                  <checkboxcomponent class="test_opacity" :item1="item7" />
    </div>
    <scarica :item1="scarica_method" :attendi="attendi" />  
    <p> {{percentage}} </p>
    <div class="sto_scaricando" :class="attendi"> </div>
  </v-container>
</template>

<script>
import axios from "axios";
import FileDownload from "js-file-download";
import interceptor from "../classes/class_interceptor";
import checkboxcomponent from "./downloader/checkbox.vue";
import scarica from "./downloader/scarica.vue";
import checkLanguage from "../classes/class_check_language";
import is_localhost from "../classes/class_is_localhost";

export default {
  name: "downloaderMainComponent",
    data: () => ({
      subtitle: 'Seleziona e scarica ciò di cui hai bisogno',
      attendi: '',
      attendere_prego: '',
      percentage:'',
    }),

      mounted() {
    // controllo se inglese 
    this.i = new checkLanguage();
    if (!this.i.is_italian()){
      this.subtitle = "Select and download what you need";
      this.$store.commit('change_language_download');
    }
  },
  components: {
    checkboxcomponent,
    scarica,
  },
  computed: {
    item1() {
      return this.$store.state.items.item1;
    },
    item2() {
      return this.$store.state.items.item2;
    },
    item3() {
      return this.$store.state.items.item3;
    },
    item4() {
      return this.$store.state.items.item4;
    },
    item5() {
      return this.$store.state.items.item5;
    },
    item6() {
      return this.$store.state.items.item6;
    },
    item7() {
      return this.$store.state.items.item7;
    },
    button_download() {
      return this.$store.state.button_download;
    },
      codicearticolo_value(){
                return this.$store.state.product_store.CODICE_UNIVOCO;
        },

  
 
  },

  async created() {
    let i = new interceptor();
    i.lazy_load_script("app");
  },
  methods: {
    download_file(url, label) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          FileDownload(response.data, label + ".easm");
        })
        .catch(console.error);
    },
    scarica_method() {
      let items = this.$store.state.items;
      // controlla ogni elemento se è selezionato devo aggiungere la variabile da passare al backend per scaricare il file
        let selected=[];
        try{
      Object.keys(items).forEach((key) => {
        if (items[key][0].selected ) {
          selected+=key+',';
        }
      });
           } catch (error) {
            console.info(error);
        }
        if (this.$store.state.product.language == 'en'){
          selected+='en';
        }
        this.download_zip(selected);
    },
    download_zip(selected) {
      let that = this;
        let ur = new is_localhost();
    let url = ur.return_url_website();
     let lang = document.documentElement.lang;
      const site =
        url+"wp-script/zip/zip.php?pk="+this.codicearticolo_value+"&selected="+selected+"&lang="+lang;
      //this.$store.commit("is_loading_downloader", { is_loading: true });
      this.attendi = 'attendi';
      this.attendere_prego = 'attendere prego stiamo preparando le tue risorse';
        this.i = new checkLanguage();
    if (!this.i.is_italian()){
      this.attendere_prego ='please wait we are preparing your resources';
    }

    axios({
    method: "GET",
    url: site, //
    responseType: "arraybuffer",
    config: {
        headers: {
              'Content-Type': 'application/json',
                'Accept': 'application/pdf'

        }
    },
       onDownloadProgress: (progressEvent) => {
     
      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
let me = that.attendere_prego 
      that.attendere_prego = me + ' ' + percentCompleted +'%';
      this.percentage = percentCompleted +'%';
    },
}).then(function(response) {
    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', "documentation_"+that.codicearticolo_value+".zip");
    document.body.appendChild(link);
    link.click();
     that.$store.commit("is_loading_downloader", { is_loading: false });
        that.percentuale = '';
        that.attendere_prego = '';
      that.attendi='';
       that.percentage = '';

})
.catch(function(error) {
  alert(error);
  that.$store.commit("is_loading_downloader", { is_loading: false });
  that.percentuale = '';
      that.attendi='';
  that.percentage = '';
  
});



    },
  },
};
</script>

<style scoped>
.column-download{
  display: flex; flex-direction: row; justify-content:space-between;
}
@media only screen  and (max-width: 1019px){
.column-download[data-v-27233d0b] {
    display: flex;
    flex-direction: column;
}

}
@media only screen  and ( min-width:1020px ) and (max-width: 1326px){
.column-download {
    display: flex;
    flex-direction: row;
    width:90vw !important;
}
.wrapper_product_downloader #element_to_intercept{
  margin-left: 9vw !important;
}
}

@media only screen  and ( min-width:1020px ) and (max-width: 1926px){
.column-download {
    display: flex;
    flex-direction: row;

}

}
@media only screen  and (max-width: 1100px){

h3{
  padding-left:26px !important;
}

}
@media only screen  and (min-width: 1100px){
.column-download{
  padding-left: 30px;
  padding-right: 30px;
}
}
.title-download {
  padding-top: 57px;
  padding-left: 60px;
  color: #000000;
  font-size: 2.5rem;
  font-weight: 550;
  padding-bottom:0px;
}
.subtitle-download {
  padding-top: 0px;
  padding-left: 60px;
  padding-bottom: 0px;
  color: #000000;
     font-size: 1.25rem;
  font-weight: 500;
}
.title-download-button {
  font-size: 1.2rem !important;
  font-weight: 400;
  line-height: 1.75rem;
  letter-spacing: 0.009375em !important;
  font-weight: 700;
  padding-top: 5px;
  scroll-padding-bottom: 3px;
  font-family: "Montserrat";
}
.subtitle-download-button {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.03125em !important;
  padding-top: 8px;
  font-family: "Montserrat";
}

.button-download-main {
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em !important;
  font-family: "Montserrat";
  font-weight: 600;
  border-color: black;
  color: #000000;
}

.v-list-item--active::before,
.v-list-item:focus::before {
  opacity: 0 !important;
}

/* ADJUST HEIGHT WIDTH AND PADDING OF THE ENTIRE BLOCK DOWNLOAD  */
.brownClass {
  background: #E3DED9;
  margin-top: 5% !important;
  max-width: 93% !important;
}

#download_wrapper #app {
  background: #E3DED9 !important;

  max-width: 100% !important;
}
.disabled {
  pointer-events: none !important;
  opacity: 0.5;
}
.test_opacity{
  opacity: 0.001;
}
.attendi{
  pointer-events: none;
  opacity: 0.5;
  animation: glowing 1500ms infinite;
}
.sto_scaricando{
  width:550px;
}

@keyframes glowing {
  0% { box-shadow: 0 0 -10px #dcdbd7; }
  40% { box-shadow: 0 0 20px #dcdbd7; }
  60% { box-shadow: 0 0 20px #dcdbd7; }
  100% { box-shadow: 0 0 -10px #dcdbd7; }
}
</style>